export default {
    SET_NAV_MENU: 'SET_NAV_MENU',
};
